export const INPUT_CTA_ASSET_FINANCE = {
  title: 'Free eligibility check for Asset Finance',
  info: 'Our finance experts will work with you to provide a free eligibility check for your Asset Finance application along with how likely you are to be successful.'
}

export const INPUT_CTA_RECOVERY_LOANS = {
  title: 'Free eligibility check for Recovery Loan Scheme (RLS)',
  info: 'Our finance experts will work with you to provide a free eligibility check for your RLS application along with how likely you are to be successful.'
}
